import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit() {
    this.title.setTitle('Creative Features - Talespinner.io | AI-Powered Storytelling Platform');
    this.meta.updateTag({ name: 'description', content: 'Explore the limitless creative possibilities with Talespinner.io. From character creation to world-building, discover how our AI-powered platform can help you craft unique and captivating stories.' });
    this.meta.updateTag({ name: 'keywords', content: 'Talespinner features, AI writing, character creation, world-building, creative writing, storytelling, genre blending' });
  }
}
